// extracted by mini-css-extract-plugin
export default {"multiselectItem":"MultiselectItem_multiselectItem__LiHRI"};